export default function drawSvg() {

// Function to start the SVG animation
function animateSVG(svg) {
    const path = svg.querySelector('path');
    const pathLength = path.getTotalLength(); // Get the total length of the path

    // Set initial stroke-dasharray and stroke-dashoffset
    path.style.strokeDasharray = pathLength;
    path.style.strokeDashoffset = pathLength;

    // Animate the stroke using GSAP
    gsap.to(path, {
      strokeDashoffset: 0, // Reveal the stroke
      duration: 5, // Animation duration
      ease: "power2.out", // Smooth easing
    });
  }

  // IntersectionObserver to detect visibility
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Trigger the animation when the element enters the viewport
          animateSVG(entry.target);

          // Stop observing once the animation starts (optional)
          observer.unobserve(entry.target);
        }
      });
    },
    {
      root: null, // Use the viewport as the root
      rootMargin: "0px", // No margin around the root
      threshold: 0.1, // Trigger when 10% of the SVG is visible
    }
  );

  // Observe all SVGs with the class 'img-about'
  const svgs = document.querySelectorAll('.svg-draw');
  svgs.forEach((svg) => observer.observe(svg));
}
